let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d9yfl")).then(() => parcelRequire('ky1Wk'));